import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Typography,
    Modal,
    Divider,
    DialogActions,
    FormControl,
    FormControlLabel,
    FormLabel,
    TextField,
    Radio,
    RadioGroup
} from "@material-ui/core";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 3
};


export default function CredentialWalmartModal({userType, b2bTable, index, portalInfo, handleUserTypeWalmart, setB2bFormData}) {
    const [open, setOpen] = useState(false);
    const [errors, setErrors] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [userData, setUserData] = useState({
        username: portalInfo.username,
        password: portalInfo.password,
        rut: portalInfo.rut,
        idCredentialSymantec: (portalInfo.rut || {}).username || "",
        passwordSymantec: (portalInfo.rut || {}).password || "",
    });

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const modifyUserData = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setUserData({
            ...userData,
            [name]: value,
        })
    }

    const validateForm = () => {
        const elementCount = {};

        errors.forEach((e) => {
            elementCount[e] = (elementCount[e] || 0) + 1
        })

        Object.keys(userData).forEach((d) => {
            if (
                (userType == "bot"
                && d !== "idCredentialSymantec"
                && d !== "passwordSymantec")
                || (
                    userType == "symantec"
                    && d !== "rut"
                )
            ) {
                if (d === "rut" && userType === "bot" && userData[d] && userData[d].length < 500) {
                    setErrors(errors => [...errors, d]);
                } else if (userType === "symantec" && d === "idCredentialSymantec" && userData[d] && userData[d].length !== 12) {
                    setErrors(errors => [...errors, d]);
                } else if (userType === "symantec" && d === "passwordSymantec" && userData[d] && userData[d].length !== 32) {
                    setErrors(errors => [...errors, d]);
                } else if (!userData[d] && !errors.includes(d)) {
                    setErrors(errors => [...errors, d])
                } else if (elementCount[d] && elementCount[d] === 1 && userData[d]) {
                    setErrors(errors => errors.filter(e => e !== d));
                }
            }
        });

        setIsSaving(true);
    }

    useEffect(() => {
        if (!errors.length && isSaving) {
            saveData();
        } else {
            setIsSaving(false);
        }
    }, [isSaving])

    const saveData = () => {
        const portalData = {...userData};

        if (userType === "symantec") {
            portalData.rut = {
                "username": userData.idCredentialSymantec,
                "password": userData.passwordSymantec,
            }
        }

        const b2bSingularData = b2bTable[index];
        b2bSingularData.username = portalData.username;
        b2bSingularData.password = portalData.password;
        b2bSingularData.rut = portalData.rut
        const b2bFormDataCopied = b2bTable;
        b2bFormDataCopied[index] = b2bSingularData;
        setB2bFormData(b2bFormDataCopied);
        setIsSaving(false);
        setOpen(false);
    }

    return (
        <div>
        <Button className="isv-btn isv-btn-circle" onClick={handleOpen}>
            Credenciales
        </Button>
        <Modal
            open={open}
            onClose={saveData}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style} component="form" autoComplete="off">
                <Typography id="modal-modal-title" variant="h4">
                    Ingresar Credencial
                </Typography>
                <Divider />
                <br />
                <FormControl className="MuiFormControl-fullWidth">
                    <FormLabel>Usuario</FormLabel>
                    <TextField
                        error={errors.includes("username")}
                        label={errors.includes("username") ? "El campo no debe quedar vacío" : ""}
                        variant="outlined"
                        name="username"
                        onChange={modifyUserData}
                        value={userData.username}
                    />
                </FormControl>
                <br/>
                <FormControl className="MuiFormControl-fullWidth">
                    <FormLabel>Clave</FormLabel>
                    <TextField
                        error={errors.includes("password")}
                        label={errors.includes("password") ? "El campo no debe quedar vacío" : ""}
                        variant="outlined"
                        name="password"
                        onChange={modifyUserData}
                        value={userData.password}
                    />
                </FormControl>
                <br/>
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="userTypeWalmart"
                        name="userTypeWalmart"
                        value={userType}
                        onChange={e => handleUserTypeWalmart(e, index)}
                    >
                        <FormControlLabel value="bot" control={<Radio />} label="Usuario BOT" />
                        <FormControlLabel value="symantec" control={<Radio />} label="Usuario Symantec VIP" />
                    </RadioGroup>
                </FormControl>
                <br/>
                {
                    userType === "bot" && <>
                        <FormControl className="MuiFormControl-fullWidth">
                            <FormLabel>Token</FormLabel>
                            <TextField
                                error={errors.includes("rut")}
                                label={errors.includes("rut") ? "El campo debe tener al menos 500 caracteres" : ""}
                                variant="outlined"
                                name="rut"
                                onChange={modifyUserData}
                                value={userData.rut}
                            />
                        </FormControl>
                        <br/>
                    </>
                }
                {
                    userType === "symantec" && <>
                        <FormControl className="MuiFormControl-fullWidth">
                            <FormLabel>ID Credential</FormLabel>
                            <TextField
                                error={errors.includes("idCredentialSymantec")}
                                label={errors.includes("idCredentialSymantec") ? "El campo debe tener 12 caracteres" : ""}
                                variant="outlined"
                                name="idCredentialSymantec"
                                onChange={modifyUserData}
                                value={userData.idCredentialSymantec}
                            />
                        </FormControl>
                        <br/>
                        <FormControl className="MuiFormControl-fullWidth">
                            <FormLabel>Password Symantec VIP</FormLabel>
                            <TextField
                                type="password"
                                error={errors.includes("passwordSymantec")}
                                label={errors.includes("passwordSymantec") ? "El campo debe tener 32 caracteres" : ""}
                                variant="outlined"
                                name="passwordSymantec"
                                onChange={modifyUserData}
                                value={userData.passwordSymantec}
                            />
                        </FormControl>
                        <br/>
                    </>
                }
                <DialogActions>
                    <Button className="isv-btn isv-btn-circle btn-warning" onClick={handleClose}>
                        Cerrar
                    </Button>
                    <Button className="isv-btn isv-btn-circle" onClick={validateForm}>
                        Guardar
                    </Button>
                </DialogActions>
            </Box>
        </Modal>
        </div>
    );
}
